module.exports = __webpack_public_path__ + "img/guide02.894a3617.png";